import { render, staticRenderFns } from "./HomeCustomer.vue?vue&type=template&id=6d52ad25&scoped=true&"
import script from "./HomeCustomer.vue?vue&type=script&lang=ts&"
export * from "./HomeCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52ad25",
  null
  
)

export default component.exports